module.exports = __webpack_public_path__ + "img/ultra_tab_0.33e25744.svg";